/** Ключ интегратора. */
export enum IntegratorKey {
    Origin = "origin",

    /**
     * Компания **Upos**
     *
     * Интеграторы из Узбекистана.
     *
     * Домен: https://upservis.uz/
     */
    Upos = "upos",
}
